export default {
  methods: {
    closeSelect(selectEl) {
      if (selectEl) selectEl.blur()
    },
    closeSelectIfOpen(selectEl, {enabled}) {
      if (!selectEl || !enabled) return;
      if (selectEl.isMenuActive) {
        setTimeout(() => {
          selectEl.blur()
        }, 150);
      }
    }
  },

}
